<template>
  <div v-if="_visible" class="automaticActivation">
    <div class="btn">
      <el-button size="small" type="primary" @click="_visible = false">
        返回
      </el-button>
      <el-button size="small" type="primary" @click="handleBtn('add')">
        单个添加
      </el-button>
      <el-button size="small" type="primary" @click="handleBtn('import')">
        批量导入
      </el-button>
      <!-- <el-button size="small" @click="handleBtn('exportExcel')"  type="primary"> 导出</el-button> -->
    </div>
    <el-card>
      <el-form inline label-suffix="：" size="small" :model="searchForm">
        <el-form-item label="设备激活状态">
          <el-select v-model="searchForm.isActive" style="width:100px">
            <el-option label="全部" value="" />
            <el-option label="未激活" :value="0" />
            <el-option label="已激活" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select v-model="searchForm.status" style="width:100px">
            <el-option label="全部" value="" />
            <el-option label="已启用" :value="1" />
            <el-option label="未启用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="设备SN号">
          <el-input v-model="searchForm.deviceNo" maxlength="50" placeholder="" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBtn('search')">
            查询
          </el-button>
          <el-button @click="handleBtn('reset')">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <div>
      <multiple-box :visible="isSelection" :selection-num="selectionNum">
        <span class="handle-span" @click="handleConfirmval('', 1)">批量启用</span>
        <span class="handle-span" @click="handleConfirmval('', 0)">批量停用</span>
      </multiple-box>
      <el-table v-loading="listLoading" :data="list" highlight-current-row fit element-loading-text="Loading" class="list-table" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column type="index" width="55px" label="序号" />
        <el-table-column prop="deviceNo" label="设备SN号" />
        <el-table-column prop="createDate" label="创建时间" />
        <el-table-column prop="status" label="启用状态">
          <template slot-scope="scope">
            {{ scope.row.status==1?'已启用':'已停用' }}
          </template>
        </el-table-column>
        <el-table-column prop="isActive" label="设备激活状态">
          <template slot-scope="scope">
            {{ scope.row.isActive==1?'已激活':'未激活' }}
          </template>
        </el-table-column>
        <el-table-column prop="activeDate" label="激活时间" />
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <span v-if="scope.row.isActive && scope.row.status">--</span>
            <span v-else>
              <el-button v-if="!scope.row.status" type="text" size="mini" @click="handleBtn('enable',scope.row)">启用</el-button>
              <el-button v-else type="text" size="mini" @click="handleBtn('disable',scope.row)">停用</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="page"
        :limit.sync="limit"
        @handleSizeChange="getPageSize"
        @pagination="getPageSize"
      />
    </div>
    <el-dialog v-if="messageDialogVisible" width="600px" :close-on-click-modal="false" :visible.sync="messageDialogVisible" title="添加" @close="()=>{messageDialogVisible = false;editForm.deviceNo=''}">
      <el-form ref="editForm" :rules="rules" label-suffix="：" size="small" label-width="110px" :model="editForm">
        <el-form-item prop="deviceNo" label="课桌SN号">
          <el-input v-model="editForm.deviceNo" type="text" maxlength="20" />
        </el-form-item>
        <!-- <el-form-item prop="remark" label="备注">
            <el-input type="textarea" v-model="editForm.remark" maxlength="100"></el-input>
         </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="()=>{messageDialogVisible = false;editForm.deviceNo=''}">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handleAdd">
          确定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="dialogUploadVisiblePackage" :close-on-click-modal="false" :visible.sync="dialogUploadVisiblePackage" title="批量导入" width="540px" @close="dialogClose">
      <el-form label-position="right" label-width="80px">
        <!-- <el-form-item prop="remark" label="备注">
          <el-input type="textarea" rows="4" v-model="uploadData.remark" maxlength="100" style=" margin-top: 20px"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" style=" margin-bottom: 20px;vertical-align: top" icon="el-icon-download" size="medium" @click="handlerExcelTemplate">
            下载模板
          </el-button>
          <el-upload
            ref="upload"
            :on-success="onSuccess"
            :action="uploadUrl"
            :headers="uploadHeader"
            :before-upload="onBeforeUpload"
            :on-progress="onProgress"
            :on-error="onError"
            :multiple="false"
            :limit="1"
            :data="uploadData"
            name="file"
            accept=".xls, .xlsx"
            class="handle-btn"
          >
            <el-button :loading="fileUploading" size="medium" type="primary" icon="el-icon-upload2">
              {{ fileUploading?'上传文件中...':'上传文件' }}
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 批量导入异常 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogMultipleImportVisible" title="异常数据">
      <p style="padding:0 0 20px 20px;">
        导入失败，存在{{ abnormalDataList.length }}条异常记录，请修改后重新上传
      </p>
      <el-scrollbar wrap-class="abnormal-table">
        <el-table :data="abnormalDataList" fit highlight-current-row>
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="异常原因" prop="errorMsg" align="center">
            <template slot-scope="scope">
              <span style="color:red">{{ scope.row.errorMsg }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMrdeskResourceDetailsEnable,
  getMrdeskResourceDetailsDisable,
  // getMrdeskResourceDetails,
  exportExcelMrdeskResource,
  getMrdeskResourceAdd,
  getMrdeskResourceDefautImport,
  getMrdeskResourceDefautExport,
  getDeviceLotdetailsList
} from '@/api/productOperation/financialCenter/mrdeskResource.js';
import { getToken } from '@/utils/auth';
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      rules: {
        deviceNo: [{ required: true, message: 'SN不能为空', trigger: 'blur' }]
      },
      editForm: { deviceNo: null, lotId: null },
      messageDialogVisible: false,
      dialogMultipleImportVisible: false,
      dialogUploadVisiblePackage: false,
      abnormalDataList: [],
      fileUploading: false,
      uploadUrl: '', // 上传文件URL
      uploadHeader: {}, // 上传文件上传头
      uploadData: {
        lotId: ''
        // remark: ''
      },
      list: [],
      listLoading: false,
      multipleSelection: [], // 表格多选,
      searchForm: {
        deviceLotId: '',
        deviceNo: null,
        isActive: null, // 激活状态 0:未激活 1:已激活
        status: null // 状态 1:启用 0:停用
      },
      total: 0,
      page: 1,
      limit: 10
    };
  },
  computed: {
    // 返回
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    // 是否多选
    isSelection() {
      return this.multipleSelection.length > 0;
    },
    // 多选数量
    selectionNum() {
      return this.multipleSelection.length;
    }
  },
  watch: {
    id: {
      handler: function(val, oldVal) {
        this.searchForm.deviceLotId = val;
        if (oldVal !== val) {
          this.getData();
        }
      }
    }
  },
  mounted() {
    this.page = 1;
    this.searchForm.deviceLotId = this.id;
    this.editForm.lotId = this.id;
    this.uploadData.lotId = this.id;
    this.getData();
    this.initUploadData();
  },
  methods: {
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
      this.uploadUrl = getMrdeskResourceDefautImport(); // 导入
    },
    handleAdd() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          getMrdeskResourceAdd(this.editForm).then((res) => {
            if (res.code === '0') {
              this.messageDialogVisible = false;
              this.$message.success('操作成功');
              this.editForm.deviceNo = '';
              this.getData();
            }
          });
        }
      });
    },
    // 表格选择事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleConfirmval(row, status) {
      let noticeIds = [];
      if (row.id) {
        noticeIds.push(row.id);
      } else if (this.multipleSelection.length > 0) {
        noticeIds = this.multipleSelection.map(x => x.id);
      }
      this.$confirm(
        `您确认${status ? '启用' : '停用'}该数据吗?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          if (status) {
            getMrdeskResourceDetailsEnable(noticeIds).then((res) => {
              if (res.code === '0') {
                this.$message.success('操作成功');
                this.getData();
              }
            });
          } else {
            getMrdeskResourceDetailsDisable(noticeIds).then((res) => {
              if (res.code === '0') {
                this.$message.success('操作成功');
                this.getData();
              }
            });
          }
        });
    },
    handleBtn(e, row) {
      if (e === 'exportExcel') {
        const op = {
          pageSize: this.limit,
          pageNum: this.page,
          ...this.searchForm };
        window.location.href = exportExcelMrdeskResource(op) ? exportExcelMrdeskResource(op) : null;
      } else if (e === 'add') {
        this.messageDialogVisible = true;
      } else if (e === 'enable') {
        this.handleConfirmval(row, 1);
      } else if (e === 'disable') {
        this.handleConfirmval(row, 0);
      } else if (e === 'search') {
        this.page = 1;
        this.getData();
      } else if (e === 'import') {
        this.dialogUploadVisiblePackage = true;
      } else if (e === 'reset') {
        this.searchForm = {
          deviceLotId: this.searchForm.deviceLotId,
          deviceNo: null,
          isActive: null, // 激活状态 0:未激活 1:已激活
          status: null // 状态 1:启用 0:停用
        };
        this.page = 1;
        this.getData();
      }
    },
    getPageSize({ page, limit }) {
      this.page = page;
      this.limit = limit;
      this.getData();
    },
    getData() {
      this.listLoading = true;
      getDeviceLotdetailsList({
        pageSize: this.limit,
        pageNum: this.page,
        ...this.searchForm
      }).then((res) => {
        this.list = res.data.list;
        this.total = res.data.total;
        this.listLoading = false;
      }).catch(() => { this.listLoading = false; });
    },
    handlerExcelTemplate() {
      window.location.href = getMrdeskResourceDefautExport();
    },
    // 导入上传成功
    onSuccess(response, file, fileList) {
      this.fileUploading = false;
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.getData();
        this.dialogUploadVisiblePackage = false;
      } else {
        if (response.data) {
          this.dialogMultipleImportVisible = true;
          this.abnormalDataList = [];
          const list = response.data;
          list.forEach(v => {
            this.abnormalDataList.push({ errorMsg: v });
          });
        } else {
          this.$message({
            message: response.message,
            type: 'error'
          });
          this.abnormalDataList = [];
        }
      }
    },
    onBeforeUpload() {
      // if (this.uploadData.remark && this.uploadData.remark.toString().length > 50) {
      //   this.$message({
      //     message: '请输入50以内的字符',
      //     type: 'error'
      //   });
      //   return false;
      // }
    },
    // 导入 加载
    onProgress() {
      this.fileUploading = true;
    },
    onError() {
      this.fileUploading = false;
      this.$message({
        message: '文件上传失败',
        type: 'error'
      });
    },
    dialogClose() {
      this.uploadData.lotId = '';
      this.dialogUploadVisiblePackage = false;
    }
  }

};
</script>

<style lang="scss" scoped>
.automaticActivation {
  .btn {
    margin: 10px 0;
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
  .handle-btn{
    display: inline-block;
    margin-left: 20px;
  }
}
</style>
